import { DoDisturbAlt, ErrorOutline, InfoOutlined } from '@mui/icons-material';
import { Box } from '@mui/material';
import { type ReactElement } from 'react';

import { type Geschaeftsbereich, type HealthLevel, healthLevel } from '../../dtos';
import CASIcon from '../../public/assets/images/geschaeftsbereich/CAS.svg';
import DLSIcon from '../../public/assets/images/geschaeftsbereich/DLS.svg';
import IHCLCDIcon from '../../public/assets/images/geschaeftsbereich/IHC-LCD.svg';
import ILSIcon from '../../public/assets/images/geschaeftsbereich/ILS.svg';
import KFFIcon from '../../public/assets/images/geschaeftsbereich/KFF.svg';

export const renderGeschaeftsbereich = (geschaeftsbereich: Geschaeftsbereich): ReactElement => {
  let icon;
  switch (geschaeftsbereich) {
    case 'CAS':
      icon = <img src={CASIcon} alt="CAS" style={{ height: 20 }} />;
      break;
    case 'IHC':
      icon = <img src={IHCLCDIcon} alt="IHC-LCD" style={{ height: 20 }} />;
      break;
    case 'ILS':
      icon = <img src={ILSIcon} alt="ILS" style={{ height: 20 }} />;
      break;
    case 'KFF':
      icon = <img src={KFFIcon} alt="KFF" style={{ height: 20 }} />;
      break;
    case 'DLS':
      icon = <img src={DLSIcon} alt="DLS" style={{ height: 20 }} />;
      break;
    default:
      icon = undefined;
  }

  return (
    <Box display="flex" gap={0.5}>
      {icon} {geschaeftsbereich}
    </Box>
  );
};

export const renderLevel = (level: HealthLevel): ReactElement | undefined => {
  switch (level) {
    case healthLevel.ERROR:
      return <DoDisturbAlt fontSize="small" color="error" />;
    case healthLevel.WARNING:
      return <ErrorOutline fontSize="small" color="warning" />;
    default:
      return undefined;
  }
};

export const getLegendElements = (): { depiction: ReactElement; label: string }[] => [
  { depiction: <DoDisturbAlt fontSize="small" color="error" />, label: 'Fehler' },
  { depiction: <ErrorOutline fontSize="small" color="warning" />, label: 'Warnung' },
  { depiction: <InfoOutlined fontSize="small" />, label: 'Info' },
];
